import { HeadingLevel } from "types/headingLevel";

// Browser default top margins of h1 and h2, kept on the paragraphs that used to be headings so their look does not change.
export const H1_DEFAULT_MARGIN_TOP = "0.67em";
export const H2_DEFAULT_MARGIN_TOP = "0.83em";

// Tag of a heading from its level: 2 gives "h2".
export const getHeadingTag = (level: HeadingLevel): `h${HeadingLevel}` =>
    `h${level}`;
